import { render } from "./SelectorCity.vue?vue&type=template&id=0f655b52"
import script from "./SelectorCity.vue?vue&type=script&lang=js"
export * from "./SelectorCity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__